<template>
	<div>
		<div class="conBox animate__animated animate__fadeIn" data-wow-duration="0.8s">
		<div class="pageTit">
			<span>我的考试</span>
		</div>
		<!-- 筛选 -->
		<div class="shaixuan">
			<div class="catBox">
				<div class="cat flex" style="flex-wrap: nowrap;margin-bottom: 0.1rem;">
					<div class="tit" style="padding-top: 0.04rem;">方向:</div>
					<div class="f-ct" style="width: calc(100% - 1rem);">
						<div class="itm" style="margin-bottom: 0.1rem;" @click="selCat(itm)" :class="catIdx==itm.id?'a':''" v-for="(itm,idx) in catArr">{{itm.categoryName}}</div>
					</div>
				</div>
				<div class="cat flex" style="flex-wrap: nowrap;margin-bottom: 0rem;">
					<div class="tit" style="padding-top: 0.04rem;">分类:</div>
					<div class="f-ct" style="width: calc(100% - 1rem);">
						<div class="itm" style="margin-bottom: 0.1rem;" @click="selCat1(itm.id)" :class="catIdx1==itm.id?'a':''" v-for="(itm,idx) in catArr1">{{itm.categoryName}}</div>
					</div>
				</div>
			</div>
			<div class="seach f-ct">
				<div class="iptBox f-ct">
					<div class="sel">
						<el-select v-model="value" placeholder="请选择">
							<el-option
								v-for="item in options"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
					<div class="bor"></div>
					<div class="ipt">
						<el-input type="text" v-model="keyword" placeholder="请输入搜索关键词"></el-input>
					</div>
				</div>
				<div class="seachBtn f-ct">
					<div @click="courseOrderlist(1)">搜索</div>
					<div @click="keyword='',value='0',courseOrderlist(1)">重置</div>
				</div>
			</div>
		</div>
		<!-- 订单列表 -->
		<div class="orderList">
			<div class="zw" v-if="!orderList.length">
				<el-image :src="require('@/static/zw.png')"></el-image>
				<p>暂无相关数据...</p>
			</div>
			<div class="item" v-for="(item,index) in orderList">
				<div class="osn f-bct">
					<div class="l f-ct">
						<div class="time">订单编号：<span>{{item.orderNo}}</span></div>
						<div class="time" v-if="item.studyDeadline">学习截止日期：<span>{{item.studyDeadline}}</span></div>
						<!-- <div class="time">是否需要考试：<span>是</span></div> -->
						<div class="time">考试时间：<span>{{item.courseClass.examStartTime}}</span></div>
						<!-- <div class="tips">您培训的XX班级证书已制作完成，请尽快到文联路金泰酒店二楼领取</div> -->
					</div>
					<div class="r f-ct">
						<!-- <div class="status s2" v-if="1">考试不合格</div>
						<div class="status s2" v-if="1">证书编号：20250505258</div>
						<div class="status s3" v-if="1">已分班</div>
						<div class="status s3" v-if="1">考试合格</div> -->
						
						<div class="status s1" v-if="item.orderStatus==1">待支付</div>
						<div class="status s3" v-if="item.orderStatus==2">学习中</div>
						<div class="status s3" v-if="item.orderStatus==3">待分班</div>
						<div class="status s3" v-if="item.orderStatus==4">待考试</div>
						<div class="status s2" v-if="item.orderStatus==5">考试完成</div>
						<div class="status s2" v-if="item.orderStatus==6">已发证</div>
						<div class="status s4" v-if="item.orderStatus==8">已退款</div>
						<div class="status s4" v-if="item.orderStatus==9">已取消</div>
						
						<!-- <div class="status s3" v-if="item.examStatus==0">待考试</div>
						<div class="status s3" v-if="item.examStatus==1">考试通过</div>
						<div class="status s1" v-if="item.examStatus==2">考试不通过</div> -->
						
					</div>
				</div>
				<div class="msg f-bct">
					<div class="l">
						<div class="name">{{item.courseName}}</div>
						<div class="tagBox f-ct">
							<div class="tagItm" v-for="(itm,idx) in item.courseTags">{{itm}}</div>
							<div class="tagItm red">{{item.courseStudyHours}}学时</div>
						</div>
					</div>
					<div class="r">
					</div>
				</div>
				<div class="other f-bct">
					<div class="l f-ct">
						<div class="numitm">考试次数：<span>{{item.examNum}}</span></div>
						<template v-if="item.examStatus==0">
							<div class="numitm blue">理论成绩：<span>未考试</span></div>
						</template>
						<template v-if="item.examStatus==1">
							<div class="numitm blue">理论成绩：<span>{{item.examScore}}</span></div>
						</template>
						<template v-if="item.examStatus==2">
							<div class="numitm red">理论成绩：<span>{{item.examScore}} 不及格</span></div>
						</template>
						
						<template v-if="item.actualOperationExamStatus==0">
							<div class="numitm blue">实操成绩：<span>未考试</span></div>
						</template>
						<template v-if="item.actualOperationExamStatus==1">
							<div class="numitm blue">实操成绩：<span>{{item.actualOperationExamScore}}</span></div>
						</template>
						<template v-if="item.actualOperationExamStatus==2">
							<div class="numitm red">实操成绩：<span>{{item.actualOperationExamScore}} 不及格</span></div>
						</template>
						<div class="numitm" v-if="item.courseClass">所在班级：<span>{{item.courseClass.name}}</span></div>
					</div>
					<div class="r f-ct">
						<div class="b1" v-if="item.courseClass.status==2&&item.orderStatus<5&&item.examStatus==0" @click="gomonizs(item)">开始考试</div>
						<div class="b3" v-if="item.orderStatus==6" @click="zsItem=item,hbBook=true">领取证书</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 分页 -->
		<div class="fenye">
			<el-pagination
			background
			hide-on-single-page
			layout="prev, pager, next,jumper"
			@current-change="goPage"
			:page-size="pageSize"
			:total="total">
			</el-pagination>
		</div>
		</div>
		<!-- 提示框 -->
		<div class="maskBg" @click="hbBook=false" v-if="hbBook"></div>
		<div class="subTips" v-if="hbBook">
			<el-image class="cha" @click="hbBook=false" :src="require('@/static/icon57.png')"></el-image>
			<el-image class="icon" :src="require('@/static/icon73.png')"></el-image>
			<div class="t1">领取证书</div>
			<div class="t2">{{zsItem.memberCertificate.name}}，培训课程<span>【{{zsItem.courseName}}】</span>的{{zsItem.memberCertificate.certificateName}}已经制作完成。</div>
			<div class="btnBox f-ct">
				<div class="b2" @click="hbBook=false">确定</div>
			</div>
		</div>
		<!-- 结束 -->
	</div>
</template>
<script>
import { courseOrderlist,
coursecategoryList
} from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			hbBook:false,
			// 筛选
			catArr:[],
			catArr1:[],
			catIdx:0,
			catIdx1:0,
			keyword:'',
			// 分页
			pageNum:1,
			pageSize:10,
			total:0,
			// 列表
			orderList:[],
			// 其他
			options: [
				{
					value: '0',
					label: '全部'
				}, 
				{
					value: '1',
					label: '待考试'
				}, 
				{
					value: '2',
					label: '考试通过'
				}, 
				{
					value: '3',
					label: '考试不通过'
				}, 
			],
			value: '0',
			// 证书
			zsItem:'',
		}
	},
	mounted() {
		this.coursecategoryList()
		this.courseOrderlist()
	},
	methods:{
		// 正式考
		gomonizs(item){
			localStorage.setItem("kaoName", item.courseName);
			this.link('/classTest',{id:item.id})
		},
		// 选择分类
		selCat(item){
			this.catIdx = item.id
			this.catArr1 = item.childList
			this.catIdx1 = item.childList[0].id
			this.pageNum = 1
			this.courseOrderlist(1)
		},
		// 选择分类
		selCat1(id){
			this.catIdx1 = id
			this.pageNum = 1
			this.courseOrderlist(1)
		},
		// 跳转页
		goPage(e){
			this.pageNum = e
			this.courseOrderlist()
		},
		// 查询课程列表
		async courseOrderlist(def){
			if(def){this.pageNum=1}
			var data = {
				pageSize: this.pageSize,
				pageNum: this.pageNum,
				isDivideClass:1,
				payStatus:1,
				orderByColumn: 'id',
				isAsc: 'desc',
			}
			if(this.catIdx1){
				data.courseCategoryId = this.catIdx1
			}
			if(this.keyword){
				data.courseName = this.keyword
			}
			if(this.value*1){
				data.examStatus = this.value*1-1
			}
			// if(this.payStatusValue!=-1){
			// 	data.payStatus = this.payStatusValue
			// }
			let res = await courseOrderlist(data);
			if(res.code==200){
				if(this.pageNum==1){
					this.total = res.total
				}
				this.orderList = res.rows
			}else{this.Tips(res.msg,'error')}
		},
		// 分类列表
		async coursecategoryList(){
			let res = await coursecategoryList({});
			if(res.code==200){
				var catIdx = []
				res.data.categoryList.forEach((item)=>{
					item.childList = [{
						id:item.id,
						categoryName:'全部',
					},...item.childList]
				})
				this.catArr = [{
					id:0,
					categoryName:'全部',
					childList:[{
						id:0,
						categoryName:'全部'
					},...res.data.allChildCategoryList],
				},...res.data.categoryList]
				this.catArr1 = this.catArr[0].childList
			}else{this.Tips(res.msg,'error')}
		},
	},
	computed:{
		...mapState('userMsg',['userInfo']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.conBox{
	margin: 0 40px;
	background: #fff;
	border-radius: 20px;
	padding-bottom: 55px;
}
.pageTit{
	border-bottom: 1px solid #DDDDDD;
	margin: 0 24px;
	padding-top: 24px;
	padding-bottom: 14px;
	span{
		font-size: 18px;
		color: #3B6492;
		font-weight: bold;
		position: relative;
		&::after{
			content: '';
			width: 100%;
			height: 4px;
			border-radius: 4px;
			background: #3B6492;
			position: absolute;
			bottom: -14px;
			left: 0;
		}
	}
}
.shaixuan{
	// width: 100%;
	padding: 0 24px;
	// background: #fff;
	.catBox{
		padding: 24px 0;
		padding-bottom: 12px;
		// border-bottom: 1px solid #EEEEEE;
	}
	.cat{
		margin-bottom: 10px;
		&:last-child{
			margin-bottom: 0;
		}
		.tit{
			font-size: 14px;
			color: #333333;
			margin-top: 4px;
		}
		.itm{
			margin-left: 18px;
			height: 28px;
			line-height: 28px;
			padding: 0 8px;
			border-radius: 4px;
			font-size: 14px;
			color: #545964;
			margin-bottom: 12px;
		}
		.a{
			background: #E9F6FF;
			color: #3B6492;
		}
	}
	.seach{
		width: 100%;
		height: 70px;
		background: #fff;
		padding: 15px 0px;
		padding-top: 0;
		.iptBox{
			width: 1332px;
			height: 40px;
			border: 1px solid #DDDDDD;
			margin-right: 12px;
			.sel{
				.el-select{
					width: 127px;
				}
				::v-deep .el-input__inner{
					border: none;
					background: transparent;
					font-size: 14px;
				}
			}
			.bor{
				width: 1px;
				height: 20px;
				background: #DDDDDD;
			}
			.ipt{
				width: calc(100% - 130px);
				.el-select{
					width: 100%;
				}
				::v-deep .el-input__inner{
					border: none;
					background: transparent;
				}
			}
		}
		.seachBtn{
			div{
				width: 85px;
				height: 40px;
				border: 1px solid #DDDDDD;
				font-size: 16px;
				color: #666666;
				text-align: center;
				line-height: 38px;
				cursor: pointer;
				&:first-child{
					background: #3B6492;
					border: 1px solid #3B6492;
					color: #fff;
					margin-right: 12px;
				}
			}
		}
	}
}
.fenye{
	display: flex;
	align-items: center;
	justify-content: flex-end;
	margin-top: 26px;
	padding-right: 24px;
	.i1{
		width: 24px;
		height: 24px;
		margin-right: 6px;
	}
	.fyitm{
		width: 32px;
		height: 32px;
		font-size: 12px;
		text-align: center;
		line-height: 32px;
		margin-right: 6px;
		border-radius: 4px;
	}
	.a{
		background: #3B6492;
		color: #fff;
	}
	.i2{
		width: 24px;
		height: 24px;
		margin-right: 19px;
	}
	.linkPage{
		p{
			font-size: 12px;
		}
		.ipt{
			margin: 0 6px;
			width: 42px;
			height: 32px;
			border-radius: 4px;
			background: #F4F4F4;
			.el-select{
				width: 100%;
			}
			::v-deep .el-input__inner{
				border: none;
				background: transparent;
			}
		}
	}
}
.orderList{
	width: 1526px;
	margin: auto;
	.item{
		width: 100%;
		border: 1px solid #d0d2d6;
		margin-bottom: 24px;
		.osn{
			width: 100%;
			height: 60px;
			padding: 0 24px;
			border-bottom: 1px solid #EFF1F6;
			.l{
				.time{
					font-size: 14px;
					color: #7D7D89;
					margin-right: 32px;
					span{
						color: #373D50;
					}
				}
				.tips{
					font-size: 14px;
					color: #FF5F5A;
					margin-right: 32px;
				}
			}
			.status{
				min-width: 72px;
				height: 30px;
				line-height: 30px;
				text-align: center;
				border-radius: 4px;
				font-size: 14px;
				padding: 0 15px;
				margin-left: 16px;
			}
			.s1{
				color: #FF5F5A;
				background: #FFEAEA;
			}
			.s2{
				color: #E86F26;
				background: #FFF1DF;
			}
			.s3{
				color: #3B6492;
				background: #E1F1FF;
			}
		}
		.msg{
			padding: 0 24px;
			border-bottom: 1px solid #EFF1F6;
			.l{
				padding-top: 18px;
				padding-bottom: 18px;
				.name{
					font-size: 18px;color: #373D50;
					font-weight: bold;
				}
				.tagBox{
					.tagItm{
						min-width: 76px;
						margin-right: 11px;
						margin-top: 10px;
						height: 28px;
						padding: 0 10px;
						line-height: 26px;
						text-align: center;
						border-radius: 4px;
						font-size: 14px;
						color: #3B6492;
						border: 1px solid #3B6492;
					}
					.red{
						color: #FF5F5A!important;
						border: 1px solid #FF5F5A!important;
					}
				}
			}
			.r{
				font-size: 18px;
				span{
					color: #FF5F5A;
					font-weight: bold;
				}
			}
		}
		.other{
			padding: 8px 24px;
			.l{
				.blue{
					color: #3B6492!important;
					span{
						color: #3B6492!important;
					}
				}
				.red{
					color: #FF5F5A!important;
					span{
						color: #FF5F5A!important;
					}
				}
				.numitm{
					margin-right: 32px;
					font-size: 14px;
					color: #7D7D89;
					span{
						color: #373D50;
					}
				}
			}
			.r{
				justify-content: center;
				div{
					min-width: 148px;
					height: 44px;
					border-radius: 6px;
					text-align: center;
					line-height: 44px;
					font-size: 16px;
					padding: 0 26px;
					margin-left: 14px;
					cursor: pointer;
				}
				.b1{
					background: #FF5F5A;
					color: #fff;
				}
				.b3{
					background: #E86F26;
					color: #fff;
				}
				.b2{
					background: #3B6492;
					color: #fff;
					
				}
			}
		}
	}
}
.maskBg{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 10;
}
.subTips{
	position: fixed;
	width: 420px;
	// height: 364px;
	padding-bottom: 34px;
	background: #fff;
	border-radius: 8px;
	z-index: 11;
	top: 50%;
	left: 50%;
	transform: translateX(-50%)translateY(-50%);
	.cha{
		position: absolute;
		right: 20px;
		top: 20px;
		width: 14px;
		height: 14px;
	}
	.icon{
		display: block;
		margin: auto;
		margin-top: 48px;
		width: 90px;
		height: 90px;
	}
	.t1{
		font-size: 18px;
		color: #2F3541;
		font-weight: 600;
		text-align: center;
		margin-top: 25px;
	}
	.t2{
		font-size: 14px;
		color: #7D7D89;
		padding: 0 27px;
		text-align: center;
		margin-top: 12px;
		line-height: 28px;
		span{
			color: #2F3541;
		}
	}
	.btnBox{
		margin-top: 28px;
		justify-content: center;
		div{
			width: 162px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			cursor: pointer;
		}
		.b1{
			background: #E9F6FF;
			color: #3B6492;
		}
		.b2{
			background: #3B6492;
			color: #fff;
			margin-left: 14px;
		}
	}
}
</style>